// extracted by mini-css-extract-plugin
export default {"nav__icon":"Nav_icon_nav__icon__fVCRG","open":"Nav_icon_open__on1QQ"};